.infoGrid {
    padding: var(--detail-card-info-grid-padding);
}
